var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRegularUserAltGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.875C14.3789 13.875 13.8398 14.5 12 14.5C10.1602 14.5 9.625 13.875 8.5 13.875C5.60156 13.875 3.25 16.2266 3.25 19.125V20.125C3.25 21.1602 4.08984 22 5.125 22H18.875C19.9102 22 20.75 21.1602 20.75 20.125V19.125C20.75 16.2266 18.3984 13.875 15.5 13.875ZM18.875 20.125H5.125V19.125C5.125 17.2656 6.64062 15.75 8.5 15.75C9.07031 15.75 9.99609 16.375 12 16.375C14.0195 16.375 14.9258 15.75 15.5 15.75C17.3594 15.75 18.875 17.2656 18.875 19.125V20.125ZM12 13.25C15.1055 13.25 17.625 10.7305 17.625 7.625C17.625 4.51953 15.1055 2 12 2C8.89453 2 6.375 4.51953 6.375 7.625C6.375 10.7305 8.89453 13.25 12 13.25ZM12 3.875C14.0664 3.875 15.75 5.55859 15.75 7.625C15.75 9.69141 14.0664 11.375 12 11.375C9.93359 11.375 8.25 9.69141 8.25 7.625C8.25 5.55859 9.93359 3.875 12 3.875Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegularUserAltGrey);
export default __webpack_public_path__ + "static/media/icon-regular-user-alt-grey.c6da2248ca7d4f22e682eef6c98d0b8e.svg";
export { ForwardRef as ReactComponent };